import { useState } from 'react';

export default function SearchBar(props) {
 
 
    return(
        <div className='searchbar'>
            <input type='text' className='search-text' placeholder='Search product' />
        </div>
    );
}